<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="5">
        <v-card outlined class="rounded-lg text-center pa-6">
          <v-icon size="64" color="primary" v-text="'mdi-lock-outline'"></v-icon>
          <div class="text-h6 font-weight-bold mt-4">
            Hi, Please Login First
          </div>
          <p class="body-2 grey--text text--darken-1 mt-2 mb-0">
            Access all features and enjoy exploring BridgePocket
          </p>
          <v-btn
            class="mt-6"
            color="primary"
            depressed
            to="/sign-in"
            v-text="'Login'"
          ></v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "LoginFirstVue",
};
</script>
